import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

import { registerServiceWorker } from "serviceWorkerRegistration";

import Loader from "components/Loader";

const App = React.lazy(() => import("./App"));

// Используем createRoot вместо ReactDOM.render
const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

createRoot(container).render(
    <Suspense
        fallback={
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Loader animate={false} />
            </div>
        }
    >
        <App />
    </Suspense>
);

//Временно отключаем сервис-воркер для проверки
registerServiceWorker(() => {
    /*if (window.confirm(lang.system.serviceWorker.update)) {
        window.location.reload();
    } else {
        console.log("update not confirmed");
    }*/
});
